import React from "react";
import { fmt$, fmtNum, fmtMoneyByCurrency } from "../../utils/format";

const Kpi = ({ label, value, sub, deltaCls }) => (
  <div className="kpi">
    <div className="kpi__lbl">{label}</div>
    <div className="kpi__num">{value}</div>
    <div className="kpi__meta">
      {deltaCls && <span className={deltaCls}>•</span>}
      <span className="kpi__period">{sub}</span>
    </div>
  </div>
);

const KpiRail = ({ userStats, campaignStats, investmentSummary, paymentStatus }) => {
  const totalCampaigns = campaignStats?.total_campaign;
  const failed = Number(paymentStatus?.failed_transactions || 0);

  return (
    <section className="kpi-rail">
      <Kpi
        label="Total invested"
        value={fmtMoneyByCurrency(
          investmentSummary?.totalInvestmentByCurrency,
          "total",
          investmentSummary?.totalInvestmentAmount,
          0
        )}
        sub="all-time"
      />
      <Kpi
        label="Active campaigns"
        value={fmtNum(campaignStats?.active_campaign)}
        sub={totalCampaigns != null ? `of ${fmtNum(totalCampaigns)}` : "—"}
      />
      <Kpi
        label="Total users"
        value={fmtNum(userStats?.total_user)}
        sub="all"
      />
      <Kpi
        label="Accredited investors"
        value={fmtNum(userStats?.accreditedinvestor_count_total)}
        sub="verified"
      />
      <Kpi
        label="Transactions"
        value={fmtNum(investmentSummary?.transactionCount)}
        sub="completed"
      />
      <Kpi
        label="Failed payments"
        value={fmtNum(paymentStatus?.failed_transactions)}
        sub="30d"
        deltaCls={failed > 0 ? "delta-neg" : "delta-neut"}
      />
    </section>
  );
};

export default KpiRail;
